import { render, staticRenderFns } from "./rotationDashboard.vue?vue&type=template&id=266247db&scoped=true"
import script from "./rotationDashboard.vue?vue&type=script&lang=js"
export * from "./rotationDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266247db",
  null
  
)

export default component.exports